require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-imagicasa-toorak-garden-residence.json") })
        }
      }, "path---journal-imagicasa-toorak-garden-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-imagicasa-toorak-garden-residence!./.cache/json/journal-imagicasa-toorak-garden-residence.json
// module id = 501
// module chunks = 231608221292675